import { config } from '../../Config';

const GetDistinctSubcategories = async (category) => {
    const url = `${config.getDistinctSubcategories}&category=${encodeURIComponent(category)}`;

    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        });

        if (!response.ok) {
            throw new Error(`Failed to fetch subcategories: ${response.statusText}`);
        }

        const data = await response.json();


        return data.subcategories || [];
    } catch (error) {
        // console.error('Error fetching subcategories:', error);
        return [];
    }
};

export default GetDistinctSubcategories;
